import { useQuery } from '@tanstack/react-query';
import type { AgentApiCandidateBoardsIndex } from '@/types/serializers';

export default function useFetchCandidateBoards() {
  return useQuery<AgentApiCandidateBoardsIndex>({
    queryKey: ['candidateBoards'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_boards', {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch candidate boards');
      }

      return response.json();
    },
  });
}
